import React from 'react';
import { useTranslation } from 'react-i18next';

// Import images
import { ReactComponent as AppStore } from 'assets/icons/app_store_full.svg';
import { ReactComponent as GooglePlay } from 'assets/icons/google_play_full.svg';

// Import styles
import { Social } from './styles';

const FooterSocial = () => {
	const { t } = useTranslation();
	const appleUrl = t('operators_external_link_appstore');
	const androidUrl = t('operators_external_link_googleplay');

	return (
		<Social>
			<a
				target="_blank"
				rel="noopener noreferrer"
				href={appleUrl}
				aria-label="Apple store"
			>
				<AppStore />
			</a>
			<a
				target="_blank"
				rel="noopener noreferrer"
				href={androidUrl}
				aria-label="Googleplay store"
			>
				<GooglePlay />
			</a>
		</Social>
	);
};

export default FooterSocial;
